import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

import { UserService } from '@core/user.service';
import { Library } from '@core/library';

@Component({
  selector: 'app-dialog-forget-password',
  templateUrl: './dialog-forget-password.component.html',
  styleUrls: ['./dialog-forget-password.component.scss']
})
export class DialogForgetPasswordComponent implements OnInit {

  myForm: FormGroup;
  formSubmitAttempt: boolean;
  successMsg: string;
  sended = false;

  constructor(
    public dialogRef: MatDialogRef<DialogForgetPasswordComponent>,
    private fb: FormBuilder,
    private userService: UserService,
    private library: Library,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.myForm = this.fb.group({
      emailInput: new FormControl('', [
        Validators.required,
        Validators.email,
      ]),
    });
  }

  isFieldInvalid(field: string, typeError: string) {
    if (this.formSubmitAttempt && this.myForm.get(field).invalid) {
        return this.myForm.get(field).hasError(typeError);
    }

    if (this.myForm.get(field).invalid && (this.myForm.get(field).touched)) {
      return this.myForm.get(field).hasError(typeError);
    }
  }

  resetForm() {
    this.myForm.reset();
    this.formSubmitAttempt = false;
    this.myForm.markAsUntouched();
  }

  onSubmitForm() {
    this.formSubmitAttempt = true;
    if (this.myForm.invalid) {
      return;
    }

    this.library.showloading();
    const email = this.myForm.get('emailInput').value;
    this.userService.resetPassword(email).then(() => {
      this.resetForm();
      this.successMsg = 'Thư xác nhận đã được gửi tới email của bạn.';
      this.sended = true;
    }).finally(() => this.library.hideloading());
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
